import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
/**
 * Schema for the POST /me/readiness/events body.
 *
 * Frontend-fired readiness telemetry events (modal shown, Paas prompt shown,
 * dismiss outcomes). Backend-fired events (score_computed, paas_answered) go
 * directly through the readiness telemetry helper without an HTTP round-trip.
 *
 * See docs/fatigue-score/README.md §12.
 */
export const ReadinessClientEventNameSchema = z.enum([
    'readiness_modal_shown',
    'readiness_modal_dismissed_continue',
    'readiness_modal_dismissed_break',
    'readiness_break_recommended_no_action',
    'readiness_paas_prompt_shown',
]);
export const ReadinessEventBodySchema = z
    .object({
    event: ReadinessClientEventNameSchema.openapi({
        description: 'The readiness event being reported',
    }),
    sessionId: z.string().uuid().optional().openapi({
        description: 'Active session ID, if the event was fired during a session',
    }),
    score: z.number().min(0).max(1).optional().openapi({
        description: 'Readiness score visible to the user when the event fired (0..1)',
    }),
    bars: z
        .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
        .optional()
        .openapi({
        description: '5-bar score bucket visible at event time',
    }),
    stepPosition: z.number().int().nonnegative().optional().openapi({
        description: '0-indexed step position in the session, when relevant',
    }),
    secondsVisible: z.number().nonnegative().optional().openapi({
        description: 'For dismiss events: seconds the modal/prompt was visible before dismissal',
    }),
    algorithmVersion: z.string().optional().openapi({
        description: 'algorithm_version visible at event time',
    }),
})
    .openapi('ReadinessEventBody');
//# sourceMappingURL=readiness-event.schema.js.map